import { FieldError, UseFormMethods, RegisterOptions } from "react-hook-form";
import { PropsWithChildren } from "react";
import classnames from "classnames";

import "./SelectInput.style.scss";

interface SelectInputProps {
  register: UseFormMethods["register"];
  rules?: RegisterOptions;
  placeholder?: {
    label: string;
    value: string;
  };
  optional?: boolean;
  error?: FieldError;
  className?: string;
  label?: string;
  name: string;
  dataRecurly?: string;
}

interface SelectOptionProps {
  label: string;
  value: string;
}

export function SelectInput({
  register,
  placeholder,
  className,
  optional,
  children,
  rules,
  label,
  error,
  name,
  dataRecurly,
}: PropsWithChildren<SelectInputProps>) {
  return (
    <div className={`form-ctrl form-ctrl-select ${className || ""}`}>
      {label ? (
        <label className={classnames({ optional })} htmlFor={name}>
          {label}
        </label>
      ) : null}

      <select
        className={classnames({ "has-error": !!error })}
        aria-invalid={error ? "true" : "false"}
        ref={register(rules)}
        name={name}
        {...(dataRecurly ? { "data-recurly": dataRecurly } : {})}
      >
        {placeholder ? <SelectOption {...placeholder} /> : null}
        {children}
      </select>
      {error ? <span className="form-error">{error.message || "Error"}</span> : null}
    </div>
  );
}

export function SelectOption({ label, value }: SelectOptionProps) {
  return (
    <option label={label} value={value}>
      {label}
    </option>
  );
}
